import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import { StyleSheet, css } from "aphrodite";
import Popup from "reactjs-popup";
import YouTube from "react-youtube";
import { withRouter } from "react-router-dom";

import Consts from "../Constants/AppConsts.json";
import Data from "../Constants/Departments.json";
import Header from "../Components/Header";
import "./FacultyMap.css";
import Colors from "../Theme/Colors";
import { isObjectEmpty } from "../Utils";
import ImgConsts from "../Constants/ImgConsts";
import Images from "../Theme/Images";

class FacultyMap extends Component {
  constructor() {
    super();
    this.state = { currentLocation: {}, infoContent: "" };
  }
  handleMarkers = ({ map, maps }) => {
    Data.locations[this.props.floor].forEach((point) => {
      let marker = new maps.Marker({
        animation: maps.Animation.DROP,
        title: point.title,
        label: {
          text: point.title,
          color: Colors.BLUE_COLOR,
        },
        icon: {
          path: ImgConsts.icon,
          fillColor: Colors.BLUE_COLOR,
          fillOpacity: 1,
          strokeColor: Colors.WHITE_COLOR,
          strokeWeight: 1,
          anchor: new maps.Point(14, 43),
          labelOrigin: new maps.Point(13.5, -8),
        },
        position: { lat: point.latitude, lng: point.longitude },
      });
      marker.addListener("click", () => this.onClickAPoint(point));
      marker.setMap(map);
    });
  };

  onClickAPoint = (point) => {
    this.setState({ currentLocation: point, hideInfo: true });
  };

  onClosePopup = () => {
    this.setState({ currentLocation: {}, hideInfo: true });
  };

  closeInfoWindow = () => {
    this.setState({ hideInfo: true, infoContent: "" });
  };

  clickLocations = () => {
    this.setState({ hideInfo: false, infoContent: "dept_list" });
  };

  render() {
    const interestedPoint = this.state.currentLocation;
    const { hideInfo, infoContent } = this.state;
    return (
      <div className={css(styles.map)}>
        <GoogleMapReact
          bootstrapURLKeys={{
            key: Consts.Google_Maps_Key,
          }}
          defaultCenter={PageConstants.Default_Center}
          defaultZoom={PageConstants.Default_Zoom}
          options={createMapOptions}
          onGoogleApiLoaded={this.handleMarkers}
        />
        <Header
          headerText={this.props.headerText}
          subHeaderText={Consts.Header_Virtual_Faculty}
          isFaculty
          clickLocations={this.clickLocations}
          floor={this.props.floor}
          currentPath={this.props.currentPath}
          history={this.props.history}
        />
        <Popup
          open={!isObjectEmpty(interestedPoint)}
          onClose={this.onClosePopup}
          position="right center"
          className="my-popup"
        >
          <div className="popup-body">
            <header className="popup-header">{interestedPoint.title}</header>
            <header className="popup-subheader">
              {interestedPoint.description}
            </header>
            <header className="popup-subheader">Explore More</header>
            <header
              onClick={() => window.open(interestedPoint.web)}
              className="popup-links"
            >
              Official Website
            </header>
            {interestedPoint.lms ? (
              <header
                onClick={() => window.open(interestedPoint.lms)}
                className="popup-links"
              >
                Department LMS Category
              </header>
            ) : null}
            <p className="popup-body-text">If this video is not playing, please use another browser (e.g.: Firefox).</p>
            <YouTube
              videoId={interestedPoint.youtubeID}
              opts={PageConstants.Youtube}
              containerClassName="youtubeContainer"
            />
          </div>
        </Popup>
        <div className={hideInfo ? "info-box-fac hidden" : "info-box-fac"}>
          <div className="button-div">
            <input
              onClick={this.closeInfoWindow}
              alt=""
              className="close-image"
              type="image"
              src={Images.close}
            />
          </div>
          <span className="info-text">
            {infoContent === ""
              ? Consts.dept_list
              : Consts.depts.reduce((a, b) => a + "\n\n" + b)}
          </span>
        </div>
      </div>
    );
  }
}

const PageConstants = {
  USJ_BOUNDS: {
    north: 6.854708,
    south: 6.853587,
    west: 79.904015,
    east: 79.905882,
  },
  Default_Center: {
    lat: 6.853941,
    lng: 79.90502,
  },
  Default_Zoom: 20,
  Youtube: {
    playerVars: {
      autoplay: 1,
    },
  },
};

function createMapOptions(maps) {
  return {
    disableDoubleClickZoom: true,
    scrollwheel: false,
    restriction: {
      latLngBounds: PageConstants.USJ_BOUNDS,
      strictBounds: false,
    },
    styles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ],
  };
}

let styles = StyleSheet.create({
  map: {
    height: "98vh",
    width: "100%",
  },
});

export default withRouter(FacultyMap);
